// CONV-001 Sampark (named "Conversations" until 2026-10-25, D-062; owner, 2026-10-24; D-055): one inbox for the website chat, Messenger,
// Instagram, WhatsApp and TikTok. Our own wording.
export const conversationsStrings = {
  title: "Sampark",
  channelName: {
    website: "Website",
    messenger: "Messenger",
    instagram: "Instagram",
    whatsapp: "WhatsApp",
    tiktok: "TikTok",
  },
  all: "All",
  views: {
    open: "Open",
    mine: "Mine",
    unassigned: "Unassigned",
    done: "Done",
    all: "All",
  },
  search: "Search chats",
  filterChannel: "Channel",
  filterView: "Show",
  unreadOnly: "Unread only",
  unreadShort: "Unread",
  noThreads: "No conversations here",
  noThreadsBody: "New messages land here the moment a customer writes.",
  noMatch: "Nothing matches your search.",
  clearFilters: "Clear filters",
  loadMore: "Load more",
  you: "You",
  note: "Note",
  someone: "A team member",
  unknown: "Customer",
  waiting: "Waiting {time}",
  justNow: "now",
  yesterday: "Yesterday",
  today: "Today",
  unread: "{count} unread",
  pick: {
    title: "Pick a conversation",
    body: "Choose a chat on the left to read it and reply.",
  },
  shortcuts: "Shortcuts: J / K next and previous, E mark done, R reply, N note",

  thread: {
    back: "Back to the list",
    assign: "Assign",
    assignTo: "Assign to",
    assignMe: "Assign to me",
    unassign: "Unassign",
    nobody: "Unassigned",
    done: "Mark done",
    reopen: "Reopen",
    details: "Customer details",
    more: "More",
    markUnread: "Mark as unread",
    copyLink: "Copy link",
    copied: "Link copied",
    olderLoad: "Show earlier messages",
    newMessages: "New messages",
    latest: "Latest",
    sentBy: "Sent by {name}",
    retry: "Retry",
    notSent: "Not sent",
    viewProduct: "View product",
    viewOrder: "Open order",
    image: "Photo",
    order: "Order",
    status: {
      sending: "Sending",
      sent: "Sent",
      delivered: "Delivered",
      read: "Seen",
      failed: "Not sent",
    },
    event: {
      assigned: "{by} assigned this to {to}",
      assignedSelf: "{by} took this conversation",
      unassigned: "{by} unassigned this",
      done: "{by} marked this done",
      reopened: "{by} reopened this",
      reopenedByCustomer: "Reopened: the customer wrote again",
      linked: "{by} linked this chat to a customer",
    },
  },

  window: {
    open: "Reply within {time}",
    agent: "Human agent reply: {time} left",
    closed: "Reply window closed",
    noWindow: "No reply limit",
    agentHelp:
      "The 24-hour window has passed. Your reply goes out as a human agent message, allowed for 7 days after the customer's last message.",
    closedBody: {
      whatsapp:
        "WhatsApp allows free replies for 24 hours after the customer's last message. You can reply again as soon as they write. A team note still works.",
      messenger:
        "Messenger allows replies for 24 hours after the customer's last message. You can reply again as soon as they write.",
      instagram:
        "Instagram allows replies for 24 hours after the customer's last message. You can reply again as soon as they write.",
      tiktok:
        "TikTok allows replies for 48 hours after the customer's last message. You can reply again as soon as they write.",
      website: "This website chat has ended. You can reply again as soon as the customer writes.",
    },
  },

  composer: {
    reply: "Reply",
    note: "Note",
    replyPh: "Reply on {channel}. Type / for quick replies",
    notePh: "Write a note only your team sees. It's never sent to the customer.",
    send: "Send",
    addNote: "Add note",
    sending: "Sending",
    quickReplies: "Quick replies",
    product: "Send a product",
    order: "Send an order",
    emoji: "Emoji",
    enterHint: "Enter to send · Shift + Enter for a new line",
    noQuick: "No quick replies yet.",
    manageQuick: "Manage quick replies",
    productSearch: "Search products",
    noProducts: "No product matches.",
    noOrders: "This customer has no orders yet.",
    tooLong: "Keep it under {max} characters.",
    noteBadge: "Only your team sees notes",
  },

  contact: {
    title: "Customer",
    phone: "Phone",
    email: "Email",
    handle: "Account",
    channel: "Channel",
    started: "First message",
    assigned: "Assigned",
    copy: "Copy",
    copied: "Copied",
    call: "Call",
    linked: "Customer record",
    notLinked: "Not linked to a customer yet",
    findCustomer: "Find a customer by name or phone",
    link: "Link",
    unlink: "Unlink",
    createCustomer: "Add as new customer",
    created: "Customer added",
    linkedToast: "Linked to {name}",
    orders: "Orders",
    spent: "Spent",
    lastOrder: "Last order",
    recentOrders: "Recent orders",
    noOrders: "No orders yet",
    viewCustomer: "Open customer",
    createOrder: "Create order",
    tags: "Tags",
    addTag: "Add tag",
    tagPh: "e.g. wholesale",
    noTags: "No tags",
    hide: "Hide details",
    orderCreated: "Order created",
    sendToChat: "Send to chat",
  },

  channels: {
    title: "Channels",
    open: "Channels",
    lead: "Connect your store's chat accounts. Every message from them arrives here, and your replies go back on the same app.",
    connected: "Connected",
    pending: "Waiting for approval",
    off: "Not connected",
    error: "Needs attention",
    connect: "Connect",
    manage: "Settings",
    disconnect: "Disconnect",
    disconnectConfirm:
      "Disconnect {channel}? New messages stop arriving here. Past chats stay in Sampark.",
    disconnected: "{channel} disconnected",
    connectedToast: "{channel} connected",
    reconnect: "Reconnect",
    notReady:
      "Adyvance is still finishing approval with {platform}. You can connect once it's ready.",
    about: {
      website:
        "A chat bubble on your online store. Shoppers write to you without leaving the page.",
      messenger: "Messages to your Facebook Page.",
      instagram: "Direct messages to your Instagram business account.",
      whatsapp: "Messages to your WhatsApp business number.",
      tiktok: "Direct messages to your TikTok business account.",
    },
    needs: {
      website: "Nothing to set up. Turn it on.",
      messenger: "A Facebook Page you manage.",
      instagram: "An Instagram Business or Creator account linked to your Facebook Page.",
      whatsapp: "A phone number for WhatsApp. It can be the number on your WhatsApp Business app.",
      tiktok: "A TikTok Business account.",
    },
    youNeed: "You need:",
    waiting: "Waiting for {platform}",
    waitingBody: "Finish signing in on the window that opened. This updates by itself.",
    connectFailed: "{platform} said: {reason} Try again.",
    notConnected: "{channel} isn’t connected, so replies can’t be sent. Reconnect it to reply.",
    withFacebook: "Continue with Facebook",
    withWhatsapp: "Connect WhatsApp",
    withTiktok: "Continue with TikTok",
    // D-098: WhatsApp by hand until Adyvance is a Meta Tech Provider.
    manual: {
      toggle: "Connect with your number's details instead",
      lead: "Use this if the WhatsApp window says the app isn't available. You need a WhatsApp number in Meta (your own, or Meta's free test number).",
      phoneId: "Phone number ID",
      phoneIdHelp: "Meta for Developers → your app → WhatsApp → API Setup.",
      wabaId: "WhatsApp Business account ID",
      wabaIdHelp: "Shown on the same API Setup page.",
      token: "Permanent access token",
      tokenHelp:
        "Meta Business settings → System users → Generate token, for the Adyvance app, with whatsapp_business_messaging and whatsapp_business_management. It's kept encrypted and never shown again.",
      submit: "Connect number",
    },
    redirectNote:
      "{platform} opens in a new window. Sign in there and choose the account to connect.",
    choosePage: "Choose the Page to connect",
    chooseAccount: "Choose the account to connect",
    choose: "Connect this",
    since: "Connected {date}",
    website: {
      on: "Chat bubble on your store",
      greeting: "Greeting",
      greetingDefault: "Hi! How can we help you today?",
      away: "Message when you're away",
      awayDefault: "Thanks for your message! We usually reply within a few hours.",
      askPhone: "Ask for a phone number before the chat starts",
      position: "Bubble position",
      right: "Bottom right",
      left: "Bottom left",
      preview: "Preview",
      save: "Save",
      saved: "Website chat saved",
      formsLink: "Contact and complaint form messages are in Customers → Inbox.",
      openForms: "Open Inbox",
      previewName: "Your store",
      previewOnline: "Usually replies in a few hours",
      previewInput: "Write a message…",
      previewPhone: "Phone number",
    },
    quick: {
      title: "Quick replies",
      lead: "Saved answers for questions customers ask often. Type / in the reply box to use one.",
      add: "Add quick reply",
      shortcut: "Shortcut",
      shortcutPh: "e.g. price",
      name: "Name",
      body: "Message",
      save: "Save",
      saved: "Quick replies saved",
      remove: "Remove",
      empty: "No quick replies yet.",
      edit: "Edit",
      done: "Done",
      cancel: "Cancel",
    },
    close: "Close",
    openInbox: "Open Sampark",
    section: {
      title: "Customer messages",
      lead: "Connect your chat apps. Every message arrives in Sampark, and your replies go back on the same app.",
    },
    how: {
      title: "How it connects",
      website: {
        s1: "Turn on the chat bubble below and write your greeting.",
        s2: "A chat bubble appears on every page of your store (not on checkout).",
        s3: "Shoppers write to you without leaving the page, and can leave their phone number.",
        s4: "Their messages arrive in Sampark. Your replies show in their chat bubble.",
        note: "Nothing to sign in to and no fees. The chat stays in the shopper's browser, so they see your reply when they come back.",
      },
      messenger: {
        s1: "Click Continue with Facebook. Facebook opens in a new window.",
        s2: "Sign in with the Facebook account that is an admin of your shop's Page.",
        s3: "Choose your Page and allow Adyvance to manage its messages.",
        s4: "Back here, pick the Page. Messages to it now arrive in Sampark, and your replies go out as your Page.",
        note: "Replies are allowed for 24 hours after the customer's last message. Replies sent from the Page inbox show here too. While Meta reviews Adyvance, ask Adyvance support to add your Facebook account as a tester before you connect.",
      },
      instagram: {
        s1: "In the Instagram app, switch to a Professional account (Business or Creator) and link it to your Facebook Page.",
        s2: "In Instagram, go to Settings → Messages and story replies → Message controls and turn on Allow access to messages.",
        s3: "Click Continue with Facebook, sign in with the account that manages that Page and allow Instagram messages.",
        s4: "Pick your Instagram account here. DMs arrive in Sampark and replies go out from your account.",
        note: "Same reply rule as Messenger: 24 hours after the customer's last message. While Meta reviews Adyvance, ask Adyvance support to add your Facebook account as a tester before you connect.",
      },
      whatsapp: {
        s1: "Click Connect WhatsApp and sign in with Facebook in the window that opens.",
        s2: "Create or choose your business portfolio and your WhatsApp Business account.",
        s3: "Add your number and confirm it with the code Meta sends by SMS or call.",
        s4: "Pick the number here. Messages to it arrive in Sampark.",
        note: "Use a number on the WhatsApp Business app or a new number, not a personal WhatsApp number. Replies are free for 24 hours after the customer's last message; after that only an approved template can restart the chat, and Meta charges for those.",
      },
      tiktok: {
        s1: "In TikTok, switch to a Business account (Settings and privacy → Account → Switch to Business account).",
        s2: "Click Continue with TikTok and sign in in the window that opens.",
        s3: "Allow Adyvance to read and send your direct messages.",
        s4: "Pick the account here. DMs arrive in Sampark.",
        note: "TikTok allows replies for 48 hours after the customer's last message. TikTok messaging isn't available for accounts registered in the EU, UK or Switzerland.",
      },
    },
  },

  onboard: {
    title: "Every customer chat, in one inbox",
    body: "Connect your website chat, Messenger, Instagram, WhatsApp and TikTok. Reply to everyone from here, with their orders beside the chat.",
    start: "Connect a channel",
    points: {
      one: "One inbox for 5 apps",
      two: "Customer and orders beside every chat",
      three: "Assign chats to your team",
    },
  },

  // root, the AI agent (D-058). Copy rule: "root" is lowercase and never starts a sentence.
  root: {
    name: "root",
    assign: "root (AI)",
    offHint: "Turn on in the inbox to assign",
    takeOver: "Take over",
    banner: {
      waiting:
        "This chat is with root. Replies start once AI is activated for your store; take over to answer the customer now.",
      live: "This chat is with root, which is answering the customer.",
    },
    event: {
      took: "Chat taken by root",
      stopped: "{by} turned root off; the chat is back with the team",
      stoppedNoCredits: "root stopped: no root AI credits left; the chat is back with the team",
      handedOff: {
        asked: "Passed to the team by root: the customer asked for a person",
        keyword: "Passed to the team by root: a hand-off word",
        limit: "Passed to the team by root after its reply limit",
        needs_team: "Passed to the team by root: it needs a person to answer",
        no_reply: "Passed to the team: root couldn't answer in time",
        plan: "Passed to the team: root isn't in your current plan",
      },
    },
    switch: {
      on: "On: root takes new and unassigned chats",
      off: "Off: turn on so root takes new and unassigned chats",
      setup: "Set up root, your AI assistant, in Apps → Integrations",
      turnedOn: "Turned on. Chats taken by root: {count}",
      turnedOff: "Turned off. Chats that were with root are back with the team.",
      noCredits: "root has no AI credits left. Buy root AI credits, then turn root on.",
      buyCredits: "Buy credits",
    },
    state: { setup: "Not set up", on: "On", off: "Off" },
    cardTitle: "root AI agent",
    cardAbout:
      "Let root, your AI assistant, answer customer chats on your channels, and pass them to your team when a person is needed.",
    aiWaitingShort: "Replies start once AI is activated",
    aiWaiting:
      "Writing replies needs Adyvance AI, which isn't activated yet. Until then, root takes chats and passes them to your team by these rules, and each chat says it is waiting; anyone can take over.",
    setUp: "Set up root",
    setUpDone: "Set up. Turn it on from the inbox or here.",
    save: "Save",
    saved: "Saved",
    reset: "Back to the recommended settings",
    inboxSwitch: "In the inbox",
    inboxSwitchHelp: "On: new and unassigned chats on the channels below go to root.",
    parts: {
      channels: "Channels and hours",
      knowledge: "Knowledge",
      orders: "Order help",
      handoff: "Hand-off",
      voice: "Tone and language",
    },
    channels: "Channels",
    channelsHint: "Where root takes new and unassigned chats while it is on.",
    hours: "When",
    hoursMode: {
      always: "Always",
      after_hours: "Outside shop hours",
      custom: "Only these hours",
    },
    shopHours: "Your shop hours (root works outside them)",
    rootHours: "Hours for root",
    from: "From",
    to: "To",
    days: { sun: "Sun", mon: "Mon", tue: "Tue", wed: "Wed", thu: "Thu", fri: "Fri", sat: "Sat" },
    knowledge: "What can root answer from?",
    knowledgeHint: "Only what you tick. Answers come from your live store data.",
    know: {
      products: "Products",
      prices: "Prices and offers",
      stock: "Stock",
      delivery: "Delivery charges and times",
      payments: "Payment methods",
      policies: "Store policies",
    },
    knowHelp: {
      products: "Names, descriptions, sizes and colours",
      prices: "Prices, discounts and coupons that are live",
      stock: "Whether an item is in stock",
      delivery: "Your delivery price lists and districts",
      payments: "Cash on delivery, eSewa, Khalti and others you accept",
      policies: "Returns, exchanges and refunds",
    },
    faqs: "Your own questions and answers",
    faqsHint: "Anything else customers often ask. Up to 30.",
    faqQ: "Question",
    faqA: "Answer",
    faqAdd: "Add a question",
    faqRemove: "Remove this question",
    orders: "Help with orders",
    ordersHint: "root never confirms, changes or cancels an order by itself.",
    order: {
      status: "Order status",
      tracking: "Tracking link",
      draft: "Draft orders",
    },
    orderHelp: {
      status: "Tells the customer where their order is (by order number and phone).",
      tracking: "Shares the courier tracking link when the parcel has one.",
      draft: "Prepares an order from the chat for your team to check and confirm.",
    },
    handoff: "When should a person take over?",
    handoffHint: "The chat goes back to Unassigned for your team.",
    needsAi: "Works once AI is activated",
    hand: {
      request: "The customer asks for a person",
      upset: "The customer seems upset",
      unsure: "Not sure of the answer",
      limit: "After a number of replies",
      limitCount: "Replies before hand-off",
      notify: "Tell the team",
    },
    handHelp: {
      request: "Words like person, staff or मान्छे, in English or Nepali.",
      upset: "Angry or unhappy messages go to a person.",
      unsure: "Instead of guessing, root passes the question on.",
      limit: "Long chats go to a person.",
      notify: "Show it in the inbox right away.",
    },
    keywords: "Hand-off words",
    keywordsHint: "Separate with commas. Any of these passes the chat to the team. Up to 20.",
    keywordsExample: "refund, wholesale, complaint",
    tone: "Tone",
    tones: { friendly: "Friendly", formal: "Formal", short: "Short and clear" },
    language: "Language",
    languages: { auto: "Match the customer", en: "English", ne: "Nepali" },
    greeting: "First message",
    greetingHint: "What root says when it takes a chat.",
    label: "Show that it's AI",
    labelHelp: "Customers see “root (AI)” next to root's replies.",
  },
} as const;
